module.exports = __webpack_public_path__ + "img/medcube2.52e33413.jpg";